// import { useForm } from 'react-hook-form';

import type { Cliente, Contrato, IDataPreventa } from '@/shared/interfaces';

import { useFetchGetByIdfactibilidadCorporativos } from '@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions';
import { useParams } from 'react-router-dom';
import { ClientesCoorporativosSave } from '.';
// import useBackDetection from '@/erp/operaciones/preagendamiento/shared/hooks/useBackDetection';
// import ClientesFibraFormTabsOnly from '../ClientesFibraFormTabsOnly';
// import ClienteFibraFormTitle from './ClienteFibraFormTitle';
// import ClienteFibraServiceFormTab from './ClienteFibraServiceFormTab';
// import ClienteFibraSummaryTFormab from './ClienteFibraSummaryTFormab';
// import { ClienteFibraDocsFormTab } from './docs';
// import { ClienteFibraPlantillaFormTab } from './plantilla';
// import { ClienteFibraPromocionesFormTab } from './promociones';
// // import { ClienteFibraRubrosFormTab } from './rubros';
// import { ClienteFibraSurveyFormTab } from './survey';
// import TrazabilidadLogFormTab from './trazabilidad-log/TrazabailidadLogFormTab';

export type SaveContractFibraProps = {
  contract: Contrato;
};

export type ClienteFibraSummaryFormType = Contrato &
  Cliente &
  IDataPreventa & {
    planLabel: string;
    permanencia: string;
    numero_contrato: string; // num ref contrato
};

export interface ClientesCoorporativosLoaderInterface {}




const ClientesCoorporativosLoader: React.FC<ClientesCoorporativosLoaderInterface> = () => {
  const { id } = useParams();
  
  const {
    data:factCorporativaData,
    isLoading:isLoadingFactCorporativa,
    // isRefetching:isRefetchingFactCorporativa,
  } = useFetchGetByIdfactibilidadCorporativos(id!)
  
  
  return (
    !isLoadingFactCorporativa?
    <ClientesCoorporativosSave factCoorporativaData={factCorporativaData?.data!}/>
    :""
  );
};

export default ClientesCoorporativosLoader;
